module.exports = __webpack_public_path__ + "img/5-5.6b3f2358.png";